import { QuestionTypes, ResponseTypes } from 'bundles/survey-form/constants/SurveyFormConstants';

import _t from 'i18n!nls/onboarding-2022';

import type { Industry } from '../types/AutoCompleteableInputProps';

export const SCREEN_WIDTH_FOR_MOBILE = 600;

export const ONBOARDING_SURVEY_BASE_ID = 'xXG7WIzZQcqfuU6hiZghNw';
export const ONBOARDING_SURVEY_VERSION = 1;

export const PATHWAYS_ONBOARDING_MVP_SURVEY_BASE_ID = 'fz4t45RXRf644R-dDjTtjg';
export const PATHWAYS_ONBOARDING_MVP_SURVEY_VERSION = 5;

// NOTE: we can't really know the length of a conditional survey
export const HACK_SURVEY_LENGTH = 5;
export const HACK_SURVEY_LENGTH_FOR_PATHWAYS_MVP = 4;
export const LOADING_PAGE_DISPLAY_TIME_MS = 2000;
export const COACH_ICON_WINK_TIME_MS = 200;

export const QUESTION_RESPONSE_TYPE_MAP = {
  [QuestionTypes.MULTIPLE_CHOICE]: ResponseTypes.MULTIPLE_CHOICE_RESPONSE,
  [QuestionTypes.CHECKBOX]: ResponseTypes.CHECKBOX_RESPONSE,
  [QuestionTypes.SHORT_ANSWER]: ResponseTypes.SHORT_ANSWER_RESPONSE,
  [QuestionTypes.NUMERIC]: ResponseTypes.NUMERIC_RESPONSE,
  [QuestionTypes.PARAGRAPH_ANSWER]: ResponseTypes.PARAGRAPH_ANSWER_RESPONSE,
  [QuestionTypes.SINGLE_CHECKBOX]: ResponseTypes.SINGLE_CHECKBOX_RESPONSE,
  [QuestionTypes.TYPEAHEAD]: ResponseTypes.TYPEAHEAD_RESPONSE,
  [QuestionTypes.DROPDOWN]: ResponseTypes.DROPDOWN_RESPONSE,
};

export const INPUT_TYPES = {
  USER_GENERATED: 'UserGenerated',
  DEFAULT: 'DefaultId',
};

export const getIndustries = (): Industry[] => {
  return [
    {
      name: _t('Agriculture'),
      id: 'agriculture',
      tags: ['cbrv1'],
    },
    { name: _t('Animation'), id: 'animation', tags: ['cbrv1'] },
    { name: _t('Architecture'), id: 'architecture', tags: ['plpv1'] },
    { name: _t('Writing and Fine Arts'), id: 'arts', tags: ['cbrv1'] },
    { name: _t('Automotive'), id: 'automotive', tags: ['cbrv1'] },
    { name: _t('Aviation'), id: 'aviation', tags: ['cbrv1'] },
    { name: _t('Construction'), id: 'construction', tags: ['cbrv1'] },
    { name: _t('Consulting'), id: 'consulting', tags: ['plpv1', 'cbrv1'] },
    { name: _t('Consumer Goods and Services'), id: 'consumer', tags: ['cbrv1'] },
    { name: _t('Defense'), id: 'defense', tags: ['cbrv1'] },
    { name: _t('Delivery'), id: 'delivery', tags: ['cbrv1'] },
    { name: _t('Dispute Resolution'), id: 'dispute-resolution', tags: ['cbrv1'] },
    { name: _t('Education'), id: 'education', tags: ['cbrv1'] },
    { name: _t('Energy'), id: 'energy', tags: ['plpv1'] },
    { name: _t('Executive'), id: 'executive', tags: ['cbrv1'] },
    { name: _t('Fashion and Design'), id: 'fashion', tags: ['cbrv1'] },
    { name: _t('Finance'), id: 'finance', tags: ['plpv1', 'cbrv1'] },
    { name: _t('Fund Raising'), id: 'fund-raising', tags: ['cbrv1'] },
    { name: _t('Furniture'), id: 'furniture', tags: ['cbrv1'] },
    { name: _t('Gambling'), id: 'gambling', tags: ['cbrv1'] },
    { name: _t('Government'), id: 'government', tags: ['plpv1'] },
    { name: _t('Government and Nonprofit'), id: 'government-international-nonprofit', tags: ['cbrv1'] },
    { name: _t('Health and Medicine'), id: 'health-medicine', tags: ['cbrv1'] },
    {
      name: _t('Healthcare (including pharmaceuticals)'),
      id: 'healthcare',
      tags: ['plpv1'],
    },
    { name: _t('Higher Education'), id: 'higher-education', tags: ['plpv1'] },
    { name: _t('Hospitality'), id: 'hospitality', tags: ['plpv1'] },
    { name: _t('Human Resources'), id: 'human-resources', tags: ['cbrv1'] },
    { name: _t('Import Export'), id: 'import-export', tags: ['cbrv1'] },
    { name: _t('Insurance'), id: 'insurance', tags: ['cbrv1'] },
    { name: _t('Legal'), id: 'legal', tags: ['plpv1', 'cbrv1'] },
    { name: _t('Libraries'), id: 'libraries', tags: ['cbrv1'] },
    { name: _t('Manufacturing'), id: 'manufacturing', tags: ['cbrv1'] },
    { name: _t('Maritime'), id: 'maritime', tags: ['cbrv1'] },
    { name: _t('Marketing'), id: 'marketing', tags: ['cbrv1'] },
    { name: _t('Media and Entertainment'), id: 'media-and-entertainment', tags: ['plpv1'] },
    { name: _t('Natural Resources'), id: 'natural-resources', tags: ['cbrv1'] },
    { name: _t('Other'), id: 'other', tags: ['cbrv1'] },
    { name: _t('Outsourcing'), id: 'outsourcing', tags: ['cbrv1'] },
    { name: _t('Public Relations'), id: 'public-relations', tags: ['cbrv1'] },
    { name: _t('Real Estate'), id: 'real-estate', tags: ['cbrv1'] },
    { name: _t('Retail'), id: 'retail', tags: ['plpv1'] },
    { name: _t('Supply Chain'), id: 'supply-chain', tags: ['cbrv1'] },
    { name: _t('Technology'), id: 'technology', tags: ['plpv1', 'cbrv1'] },
    { name: _t('Telecommunications'), id: 'telecommunications', tags: ['cbrv1'] },
  ];
};
